// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"6ddfcb38","186":"b4549aa8","215":"ef13216e","225":"8798b053","372":"90e95d05","377":"262a8a69","573":"d87cea2e","630":"22d03b11","738":"5f56b239","841":"d54e9693","856":"2a27b3fa"}[chunkId] + ".chunk.js";
};